import React from 'react';

import RepoPage from './Pages/RepoPage';
import ProfilePage from './Pages/ProfilePage';

function App() {
  return (
    <div className="container">
      <ProfilePage />
      <RepoPage />
    </div>
  );
}

export default App;
